import { styled, Typography } from "@mui/material";
import { Button, EditIcon } from "@volt_developers/components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";

import { PAGE_URLS } from "../../../constants/PageUrls";
import { TEST_IDS } from "../../../constants/TestIds";
import { TRANSLATION_KEYS } from "../../../constants/TranslationKeys";

export function ReportNotificationsCardHeader() {
  const { t } = useTranslation("connect");

  return (
    <Wrapper>
      <Typography variant="h6">
        {t(TRANSLATION_KEYS.reportNotifications)}
      </Typography>
      <Button
        component={Link}
        data-testid={TEST_IDS.reportNotificationsCardConfigureButton}
        startIcon={<EditIcon />}
        to={PAGE_URLS.notificationsSettings}
        variant="outlined"
      >
        {t(COMMON_TRANSLATION_KEYS.edit, { ns: "common" })}
      </Button>
    </Wrapper>
  );
}

const WRAPPER_MAX_HEIGHT = 24;

const Wrapper = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  maxHeight: WRAPPER_MAX_HEIGHT,
});
